import React, { useState, forwardRef, useEffect } from 'react'
import '../../pages/quotation/Forecast.scss';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { formatDate, CheckNull } from '../../utils/Validate'
import { Forecastvalidation, ForecastRequiredvalidation } from '../../pages/quotation/validation'
import FetchData, { CreateEntry, GetOne, GetList } from '../../providers/dataProvider'
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { PriceFormat, FormatValueDecimal, CurrencyConvertion } from "../../utils/Validate"
import Forecast from '../../pages/quotation/Forecast';
import Modal from "react-bootstrap/Modal";
import { ValidateMessages } from '../../constants/ValidateConstants';
import moment from "moment"

// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
        value={value}
        className="example-custom-input form-control"
        onClick={onClick}
        onChange={onChange}
        ref={ref}
    ></input>
));
// datepicker end
const defaultValues = {
    sId: 0,
    id: 0,
    forecastId: 0,
    expectedAmount: "",
    expectedQuantity: "",
    expectedDate: new Date(),
    quoteProductId: 0,
    revisionNo: 0
}

const formatHistoryDate = (dateValue, withTime = false) => {
    if (!dateValue) return "-";
    const date = moment(new Date(dateValue));
    if (!date.isValid()) return "-";
    return withTime ? date.format("DD-MMM-YYYY hh:mm A") : date.format("DD-MMM-YYYY");
};

const buildHistoryTimelineRows = (histories = []) => {
    const sortedHistories = [...histories].sort(
        (a, b) =>
            new Date(a?.revisedOn || a?.createdOn || 0) -
            new Date(b?.revisedOn || b?.createdOn || 0)
    );

    return sortedHistories.map((historyItem, index) => {

        const revisionNo =
            historyItem?.revisionNo !== undefined &&
            historyItem?.revisionNo !== null
                ? Number(historyItem.revisionNo)
                : index;

        const isInitialRevision = revisionNo === 0;

        // Original forecast date
        const forecastDate =
            index === 0
                ? historyItem?.forecastedDate ||
                  historyItem?.revisedDate ||
                  historyItem?.expectedDate
                : sortedHistories[0]?.forecastedDate ||
                  sortedHistories[0]?.revisedDate ||
                  sortedHistories[0]?.expectedDate;

        // For Rev 01 onwards, revised date is the date
        // stored in this history record.
        const revisedDate = isInitialRevision
            ? ""
            : historyItem?.revisedDate ||
              historyItem?.forecastedDate ||
              historyItem?.expectedDate;

        // Rev 00 = creation only
        // Rev 01+ = revision date/time
        const revisedOn = isInitialRevision
            ? ""
            : historyItem?.revisedOn ||
              historyItem?.createdOn;

        return {
            ...historyItem,

            revisionNo,

            revisionLabel:
                `Rev ${String(revisionNo).padStart(2, "0")}`,

            forecastedDate: forecastDate || "-",

            revisedDate: revisedDate || "-",

            revisedOn: revisedOn || "-",

            createdBy: historyItem?.createdBy || ""
        };
    });
};

const AddForecast = ({ showForecast, setOpenForecast, openForecast, currentForecast, currentQuotation, setQuotationData, currencyDetail }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [formValues, setFormValues] = useState(defaultValues)
    const [forecastList, setForecastList] = useState([]);
    const [forecastError, setForecastError] = useState({});
    const [forecastSubmit, setForecastSubmit] = useState(false);
    const [changeForecast, setChangeForecast] = useState(true);
    const [createMsg, setCreateMsg] = useState(null);
    const [forecastData, setForecastData] = useState(null);
    const [openHistory, setOpenHistory] = useState({ show: false, currentItem: null });
    const [forcasted, setForecasted] = useState({
        forecastAmount: 0,
        forecastQuantity: 0
    });
    const [show, setShow] = useState(false);
    const [forecastShow, setForecastShow] = useState(false);
    const [forecastReady, setForecastReady] = useState(false);
    const [errorShow, setErrorShow] = useState({
        show: false,
        errorMessage: "",
    });
    const [editForecast, setEditForecast] = useState(false)

    const { data: userData } = FetchData("userprofile");

    useEffect(() => {
        setForecastReady(false)
        setForecastShow(false)
        setEditForecast(false)
        setForecastList([])
        setForecastError({})
        setChangeForecast(true)
        setForecastSubmit(false)
        setForecastData(null)
        if (CheckNull(currentForecast?.quoteProductId) !== "") {
            GetOne("forecast", { id: currentForecast?.quoteProductId }, setForecastData)
        } else {
            setFormValues({
                ...defaultValues,
                expectedAmount: currentForecast?.quotedAmount || "",
                expectedQuantity: currentForecast?.quantity || ""
            })
            setForecastShow(true)
            setForecastReady(true)
        }
    }, [currentForecast, showForecast, openForecast])

    useEffect(() => {
        let newArr = []
        let forcastAmount = 0
        let forcastQuantity = 0
        forecastData?.data[0]?.productForecasts?.map((item, index) => {
            forcastAmount = forcastAmount + (item?.expectedAmount * 1)
            forcastQuantity = forcastQuantity + (item?.expectedQuantity * 1)
            let newItem = {
                ...item,
                sId: (index * 1) + 1
            }
            newArr.push(newItem)
        })
        if (newArr?.length > 0) {
            setForecastList(newArr)
            setForecasted({
                forecastAmount: forcastAmount,
                forecastQuantity: forcastQuantity
            })
        }

        const formAmount = (currentForecast?.quotedAmount * 1) - (forcastAmount * 1)
        const formQuantity = (currentForecast?.quantity * 1) - (forcastQuantity * 1)
        setFormValues((prev) => ({
            ...prev,
            expectedAmount: formAmount > 0 ? formAmount : "",
            expectedQuantity: formQuantity > 0 ? formQuantity : ""
        }))
        setForecastShow(true)
        setForecastReady(true)
    }, [forecastData])

    const HandleChange = (e) => {
        const { name, value } = e.target;
        if (name === "expectedQuantity") {
            setFormValues({
                ...formValues,
                [name]: value,
                expectedAmount: Number(currentForecast?.quotedAmount) / Number(currentForecast?.quantity) * Number(value)
            });
        } else
            setFormValues({
                ...formValues,
                [name]: value,
            });
    }

    useEffect(() => {
        setFormValues({ ...formValues, expectedDate: startDate })
    }, [startDate])

    const AddToList = () => {
        let quantity = 0
        let quotedAmount = 0
        const forecastArr = forecastList?.filter((element) => element?.sId != formValues?.sId)
        forecastArr.map((item) => {
            quantity += (item.expectedQuantity * 1)
            quotedAmount += (item.expectedAmount * 1)
        })
        setForecastError(ForecastRequiredvalidation(formValues));
        setForecastSubmit(true)
    };

    useEffect(() => {
        if (Object.keys(forecastError).length === 0 && forecastSubmit) {
            setChangeForecast(false)
             setEditForecast(false);
            if (formValues.sId > 0) {
                setForecastList(forecastList?.map((element, index) => {
                    if (element?.sId === formValues?.sId) {
                        element.sId = formValues.sId;
                        element.expectedAmount = formValues.expectedAmount;
                        element.expectedQuantity = formValues.expectedQuantity;
                        element.expectedDate = formValues.expectedDate;
                    }
                    return element;
                }
                ));
            }
            else {
                let newObj = { ...formValues, sId: (forecastList?.length === undefined ? 0 : forecastList?.length * 1) + 1 }
                if (forecastList?.length > 0)
                    setForecastList([...forecastList, newObj]);
                else
                    setForecastList([newObj]);
            }
            setForecastSubmit(false);
        }
    }, [forecastError])

    useEffect(() => {
        const { quantity, amount } = forecastList?.reduce(
            (acc, item) => {
                acc.quantity += (item?.expectedQuantity * 1) || 0;
                acc.amount += (item?.expectedAmount * 1) || 0;
                return acc;
            },
            { quantity: 0, amount: 0 }
        );

        const formAmount = (currentForecast?.quotedAmount * 1) - (amount * 1)
        const formQuantity = (currentForecast?.quantity * 1) - (quantity * 1)
        setFormValues({
            ...defaultValues,
            expectedAmount: formAmount > 0 ? formAmount : "",
            expectedQuantity: formQuantity > 0 ? formQuantity : ""
        })
    }, [forecastList])

    const DeleteForecast = (item) => {
        setChangeForecast(false)
        const list = [...forecastList];
        const temp_index = list.findIndex(x => x.sId === item.sId);
        list.splice(temp_index, 1);
        setForecastList(list);
    }
    const EditForecast = (item) => {
        setEditForecast(true)
        setFormValues({
            ...item,
            previousDate: item?.expectedDate || item?.forecastedDate || "",
            expectedDate: new Date(item?.expectedDate) > new Date() ? item?.expectedDate : new Date()
        })
    }

    const HandleSubmit = () => {
        const { quantity, amount } = forecastList?.reduce(
            (acc, item) => {
                acc.quantity += (item?.expectedQuantity * 1) || 0;
                acc.amount += (item?.expectedAmount * 1) || 0;
                return acc;
            },
            { quantity: 0, amount: 0 }
        );
        const errorObj = Forecastvalidation(quantity, amount, currentForecast)
        setForecastError(errorObj);
        if (Object.keys(errorObj).length === 0) {
            if (forecastList?.length > 0) {
                const { quantity, amount } = forecastList?.reduce(
                    (acc, item) => {
                        acc.quantity += (item?.expectedQuantity * 1) || 0;
                        acc.amount += (item?.expectedAmount * 1) || 0;
                        return acc;
                    },
                    { quantity: 0, amount: 0 }
                );

                const formAmount = (currentForecast?.quotedAmount * 1)?.toFixed(2) - (amount * 1)?.toFixed(2)
                const formQuantity = (currentForecast?.quantity * 1)?.toFixed(2) - (quantity * 1)?.toFixed(2)
                if (formAmount < 0 || (formAmount > 0 && formQuantity <= 0)) {
                    setForecastError({ ...forecastError, forcastSubmit: ValidateMessages?.FORECAST_MISMATCH })
                    return;
                }
                let newArr = []
                forecastList?.map((item, index) => {
                    let newHistoryArr = [];
                    const previousForecast = forecastData?.data?.[0]?.productForecasts?.find(prevForecast => prevForecast?.id === item?.id);
                    const previousDate = previousForecast?.expectedDate || item?.previousDate || item?.forecastedDate || "";
                    const revisedDate = item?.expectedDate || previousForecast?.expectedDate || item?.forecastedDate || null;
                   const isNewForecast = item?.id === 0;

                    const currentRevisionNo = Number(item?.revisionNo ?? 0);

                    let historyObj = {
                        forecastProductId: item?.id > 0 ? item?.id : 0,

                        // Revision 00 = original forecast date
                        forecastedDate: revisedDate,

                        // For revision 00, no revised date
                        revisedDate: isNewForecast ? null : revisedDate,

                        // Revision 00 should use created date
                        revisedOn: isNewForecast ? null : new Date(),

                        createdOn: new Date(),
                        createdBy: localStorage.getItem("authidentity"),

                        // 00, 01, 02...
                        revisionNo: currentRevisionNo
                    };
                    item?.histories?.map((historyItem, index) => {
                        newHistoryArr.push(historyItem)
                    })
                    const isChangeForecast = forecastData?.data[0]?.productForecasts?.find(prevForecast =>
                        prevForecast?.id === item?.id && (prevForecast?.expectedAmount !== item?.expectedAmount ||
                            prevForecast?.expectedQuantity !== item?.expectedQuantity || prevForecast?.expectedDate !== item?.expectedDate)
                    )
                    if (item?.id > 0 && isChangeForecast) newHistoryArr.push(historyObj)
                    if (item?.id == 0) newHistoryArr.push(historyObj)
                  let newforcastObj = {
                        ...item,
                        expectedQuantity: item?.expectedQuantity * 1,

                        // First = 0, next = 1, next = 2...
                        revisionNo: currentRevisionNo + (isNewForecast ? 0 : 1),

                        histories: newHistoryArr
                    };
                    newArr.push(newforcastObj)
                })
                let forecastDataObj = {
                    id: forecastData?.data[0]?.id,
                    quotationId: currentForecast?.quotationId,
                    quoteProductId: currentForecast?.quoteProductId,
                    createdAt: new Date(),
                    createdBy: localStorage.getItem("authidentity"),
                    productForecasts: newArr
                }

                CreateEntry("forecast", forecastDataObj, setCreateMsg, "Forecast added", "Failed to add forecast")
            }
            else {
                setForecastError({ ...forecastError, forcastSubmit: ValidateMessages?.FORECAST_REQUIRED })
            }
        }
    }

    useEffect(() => {
        if (CheckNull(createMsg?.message).includes('Failed')) {
            let errorsmsg = createMsg.successData;
            setErrorShow({
                show: true,
                errorMessage: errorsmsg,
            });
        } else if (CheckNull(createMsg?.message) == "Forecast added") {
            setOpenForecast(false)
            setShow(true);
            if (CheckNull(currentForecast?.quoteProductId) !== "") {
                GetList("forecast", { quoteId: currentQuotation?.id }, setQuotationData);
            }
        }
    }, [createMsg])

    const SuccessDoneClick = () => {
        setShow(false); setCreateMsg(null);
    }
    const ErrorDoneClick = () => {
        setErrorShow({
            show: false,
            errorMessage: "",
        });
    };

    const HandleOpenHistory = (item) => {
        setOpenHistory({ show: true, currentItem: item });
        setOpenForecast(false);
    }

    const HandleCloseHistory = () => {
        setOpenHistory({ show: false, currentItem: null });
        setOpenForecast(true);
    }

    return (<>
        <Modal size='sm' show={openForecast} className='forecastRightSideModalPopup drawer right-align'>
            <Modal.Header>
                <h5 className="modal-title">{currentForecast?.productGroupName} - {currentForecast?.productName}</h5>
                <i className="fas fa-times" onClick={() => { setOpenForecast(false), setEditForecast(false), setForecastList([]) }}></i>
            </Modal.Header>
            <Modal.Body>
                <div className='row modal-row mt-2'>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4">
                        <div className='quoted-col'>
                            <p>Quoted ({currencyDetail?.shortCode})</p>
                            <h4>{FormatValueDecimal(CurrencyConvertion(currentForecast?.quotedAmount, currentQuotation?.row?.conversionRate, currencyDetail))}</h4>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4 ">
                        <div className='forecasted-col'>
                            <p>Forecasted ({currencyDetail?.shortCode})</p>
                            <h4>{FormatValueDecimal(CurrencyConvertion(currentForecast?.forecastedAmount, currentQuotation?.row?.conversionRate, currencyDetail))}</h4>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-4">
                        <div className='balance-col'>
                            <p>Balance ({currencyDetail?.shortCode})</p>
                            <h4>{FormatValueDecimal((CurrencyConvertion(currentForecast?.quotedAmount, currentQuotation?.row?.conversionRate, currencyDetail) * 1) - ((CurrencyConvertion(currentForecast?.forecastedAmount, currentQuotation?.row?.conversionRate, currencyDetail)) * 1))}</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0">
                        <div className='header mt-2'>
                            <h6>Forecast Details</h6>
                        </div>
                    </div>
                    {forecastReady && forecastShow && ((!forecastList || forecastList?.length === 0) || editForecast) && (
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className='mt-2'>
                            <label>Date</label>
                            <DatePicker
                                selected={new Date(formValues?.expectedDate)}
                                onChange={(date) => setStartDate(date)}
                                customInput={<ExampleCustomInput />}
                                dayClassName={() => "example-datepicker-day-class"}
                                popperClassName="example-datepicker-class"
                                todayButton="TODAY"
                                popperPlacement="bottom-start"
                                popperProps={{ strategy: "fixed" }}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                            />
                        </div>
                        <div className='d-flex justify-content-between gap-2 align-items-start'>
                            <div className='mt-2'>
                                <label>Quantity</label>
                                <div>
                                    <input className='form-control' disabled="true" value={formValues?.expectedQuantity} name="expectedQuantity" type="text" placeholder='Enter' onChange={HandleChange}></input>
                                    {forecastError?.expectedQuantity && <p className="form-error">{forecastError?.expectedQuantity}</p>}
                                </div>
                            </div>
                            <div className='mt-2 ml-2'>
                                <label>Forecast Amount</label>
                                <div className='d-flex'>
                                    <input className='form-control' disabled="true" value={(formValues?.expectedAmount * 1) > 0 ? PriceFormat(CurrencyConvertion(formValues?.expectedAmount, currentQuotation?.row?.conversionRate, currencyDetail)) : ""} name="expectedAmount" type="text" placeholder='Enter'></input>
                                    <button type="button" className='btn add-btn' onClick={AddToList}>{formValues?.sId > 0 ? "Update" : "Add"}</button>
                                </div>
                                {forecastError?.expectedAmount && <p className="form-error">{forecastError?.expectedAmount}</p>}
                            </div>
                        </div>
                        {forecastError?.quotedAmount && <p className="form-error">{forecastError?.quotedAmount}</p>}
                        {forecastError?.quantity && <p className="form-error">{forecastError?.quantity}</p>}
                        {forecastError?.forcastSubmit && <p className="form-error">{forecastError?.forcastSubmit}</p>}
                    </div>
                    )}
                </div>
                {forecastList?.length > 0 && (
                <div className='row forecast-amount-table-row mt-3'>
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className='table-responsive'>
                            <table className='table table-borderless m-0 forecast-table'>
                                <thead>
                                    <tr>
                                        <th>Forecast Amount</th>
                                        <th>Date</th>
                                        <th>Quantity</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        forecastList?.map((item, index) => {
                                            return (
                                                <tr>
                                                    <td data-label="Forecast Amount">{FormatValueDecimal(CurrencyConvertion(item?.expectedAmount, currentQuotation?.row?.conversionRate, currencyDetail))}</td>
                                                    <td data-label="Date">{moment(new Date(item?.expectedDate)).format("DD-MMM-YYYY")}</td>
                                                    <td data-label="Quantity">{item?.expectedQuantity}</td>
                                                    <td>
                                                        <span><i className="far fa-edit mr-2" title="Edit" onClick={() => EditForecast(item)}></i></span>
                                                        {item?.histories && <span><i className="fa fa-history mr-2" title="History" onClick={() => HandleOpenHistory(item)}></i></span>}
                                                        {item?.forecastId === 0 && <span><i className="far fa-trash-alt" title="Delete" onClick={() => DeleteForecast(item)}></i></span>}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-end">
                    <div className="text-align">
                        <button type="button" className="btn cancel-btn mr-3"
                            onClick={() => { setOpenForecast(false), setEditForecast(false), setForecastList([]) }}>Cancel</button>
                    </div>
                    <div className="text-align">
                        <button type="button" className="btn save-btn" disabled={changeForecast} onClick={HandleSubmit}>Save</button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
            <Modal size='sm' show={openHistory?.show} className='historyRightSideModalPopup drawer right-align'>
                <Modal.Header>
                    <div className='d-flex align-items-center'>
                        <i class="fas fa-chevron-left" onClick={() => { HandleCloseHistory(); }}></i>
                        <h5 className="modal-title ml-2">Forecast History</h5>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className='row forecast-history-table-row mt-3'>
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className='table-responsive'>
                            <table className='table table-borderless m-0'>
                                <thead>
                                    <tr>
                                        <th>Revision</th>
                                        <th>Forecast Date</th>
                                        <th>Revised Date</th>
                                        <th>Revised On</th>
                                        <th>Revised By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {buildHistoryTimelineRows(
                                        openHistory?.currentItem?.histories || []
                                    ).map((historyItem, historyIndex) => {

                                        const filterUser = userData?.find(
                                            (userItem) =>
                                                userItem?.identityId === historyItem?.createdBy
                                        );

                                        const revisionNo = Number(
                                            historyItem?.revisionNo ?? historyIndex
                                        );

                                        const isInitialRevision = revisionNo === 0;

                                        return (
                                            <tr key={historyIndex}>
                                                <td className="text-nowrap">
                                                    Rev {String(revisionNo).padStart(2, "0")}
                                                </td>
                                                <td className="text-nowrap" data-label="Forecast Date">
                                                    {formatHistoryDate(
                                                        historyItem?.forecastedDate
                                                    )}
                                                </td>
                                                <td className="text-nowrap" data-label="Revised Date">
                                                    {isInitialRevision
                                                        ? "-"
                                                        : formatHistoryDate(
                                                            historyItem?.revisedDate
                                                        )}
                                                </td>
                                                <td className="text-nowrap" data-label="Revised On">
                                                    {isInitialRevision
                                                        ? "-"
                                                        : formatHistoryDate(
                                                            historyItem?.revisedOn,
                                                            true
                                                        )}
                                                </td>
                                                <td className="text-nowrap" data-label="Revised By">
                                                        {filterUser?.firstName || ""} {filterUser?.lastName || ""}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        <SaveSuccessModel
            createMsg={createMsg}
            setCreateMsg={setCreateMsg}
            setShow={setShow}
            show={show}
            SuccessDoneClick={SuccessDoneClick}
        />
        <ErrorMessage
            Show={errorShow?.show}
            errorMessage={errorShow?.errorMessage}
            ErrorDoneClick={ErrorDoneClick}
        />
    </>
    )
}

export default AddForecast
